__turbopack_context__.v({
  "alreadyMember": "CheckAudio-module-scss-module__tyBPka__alreadyMember",
  "audioContainer": "CheckAudio-module-scss-module__tyBPka__audioContainer",
  "audioPage": "CheckAudio-module-scss-module__tyBPka__audioPage",
  "buttonContainer": "CheckAudio-module-scss-module__tyBPka__buttonContainer",
  "description": "CheckAudio-module-scss-module__tyBPka__description",
  "fade": "CheckAudio-module-scss-module__tyBPka__fade",
  "fade-slide": "CheckAudio-module-scss-module__tyBPka__fade-slide",
  "open-from-center": "CheckAudio-module-scss-module__tyBPka__open-from-center",
  "spin": "CheckAudio-module-scss-module__tyBPka__spin",
});
